import React from "react";
import { Loader2 } from "lucide-react";
// import { IconType } from "react-icons";

interface CustomButtonProps {
  startIcon?: string;
  endIcon?: string;
  isLoading?: boolean;
  disabled?: boolean;
  color?: string;
  borderRadius?: string;
  icon?: string;
  children: React.ReactNode;
    onClick?: () => void;
    className?: string;
    rounded?: boolean;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  isLoading,
  disabled,
  color = "",
  rounded,
  icon,
    children,
  className,
  startIcon,
  endIcon,
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      className={`flex items-center text-[15px] justify-center   ${color} ${
        rounded ? "rounded-[29px]" : "rounded-[5px]"
      }   hover:brightness-95 ${className}   `}
      disabled={isLoading || disabled}
    >
      {startIcon && (
        <img alt="icon" src={startIcon} className="mr-2 h-[15px] w-[15px]"  />
      )}
      {isLoading && <Loader2 className="mr-2 animate-spin" />}
      {icon && !isLoading && (
        <img  src={icon}  alt="" className="mr-2 h-[20px] w-[20px]" />
      )}
      {children}
      {endIcon && (
        <img alt="icon" src={endIcon} className="ml-2 h-[22px] w-[22px]"  />
      )}
    </button>
  );
};

export default CustomButton;